import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import dynamic from 'next/dynamic'
import { withI18next } from 'lib/i18n/withI18next'
import addressesAPI from 'lib/api/address'
import NoopLoader from 'components/noop-loader'
import Loader from 'components/loader'
import PickUpAccordion from 'components/offline/pick-up-accordion'
import styles from './styles.scss'

const LocationRows = dynamic(() => import('components/offline/locations-row'), {
  ssr: false,
  loading: NoopLoader,
})

class StoreLocations extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      addressLocations: [],
      selectedLocation: null,
    }
  }

  async componentDidMount() {
    const { internationalization } = this.props

    const res = await addressesAPI.getPickUpPoints({
      shop_id: internationalization.shop,
      pickup_type: 'store',
    })

    if (res?.pickup?.length > 1) {
      this.setState({ addressLocations: res.pickup })
    } else if (res?.pickup?.length === 1) {
      this.setState({
        addressLocations: res.pickup,
        selectedLocation: res.pickup[0],
      })
    }
  }

  getThreeLocations(addressLocations) {
    const dataPerRow = 3
    const locations = []
    const numberOfRows = addressLocations.length / dataPerRow
    for (let i = 0; i < numberOfRows; i += 1) {
      const data = addressLocations.slice(i * dataPerRow, (i + 1) * dataPerRow)
      locations.push(data)
    }
    return locations
  }

  selectStore = (store) => {
    const { selectedLocation } = this.state
    if (
      selectedLocation &&
      selectedLocation.id_pickup_location === store.id_pickup_location
    ) {
      this.setState({ selectedLocation: null })
    } else {
      this.setState({ selectedLocation: store })
    }
  }

  renderMobileView(addressLocations) {
    return <PickUpAccordion addressess={addressLocations} />
  }

  renderLocationRows = (locations) => {
    const { selectedLocation, addressLocations } = this.state

    return (
      <LocationRows
        isPhone={false}
        key={locations[0].id_pickup_location}
        locations={locations}
        selectedLocation={selectedLocation}
        selectStore={this.selectStore}
        showPreview={addressLocations.length > 1}
      />
    )
  }

  renderDesktopView(addressLocations) {
    const splitAllLocations = this.getThreeLocations(addressLocations)
    return splitAllLocations.map(this.renderLocationRows)
  }

  render() {
    const { isPhone } = this.props
    const { addressLocations } = this.state

    if (!addressLocations?.length) {
      return (
        <div className="PSC_store-section">
          <style jsx>{styles}</style>
          <div className="PSC__loader">
            <Loader />
          </div>
        </div>
      )
    }

    return (
      <div className="PSC_store-section">
        <style jsx>{styles}</style>
        {isPhone
          ? this.renderMobileView(addressLocations)
          : this.renderDesktopView(addressLocations)}
      </div>
    )
  }
}

StoreLocations.propTypes = {
  internationalization: PropTypes.shape({
    shop: PropTypes.number,
  }).isRequired,
  isPhone: PropTypes.bool.isRequired,
}

const Extended = withI18next()(StoreLocations)

export default connect((state) => ({
  internationalization: state.internationalization,
  isPhone: state.device.isPhone,
}))(Extended)
